import styled, { css } from 'styled-components';
import { SizesType, StatusButtonType } from '../ThemeProvider/types';

export const RadioContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  align-items: center;
  height: fit-content;
  font-family: 'Mulish', sans-serif;
  font-weight: 400;

  ${({ isMobile }) => {
    if (!isMobile) {
      return css`
        & > label {
          padding-left: 8px;
        }
      `;
    }

    return css`
      flex-direction: row-reverse;

      & > label {
        width: 100%;
      }
    `;
  }}
`;

export const Span = styled.span<{ size: SizesType; status: StatusButtonType }>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: solid;
  box-sizing: border-box;
  background-color: transparent;
  border-radius: 50%;

  ${({ theme, size, status }) => css`
    width: ${theme.radiobutton.sizes[size].outerCircle}px;
    height: ${theme.radiobutton.sizes[size].outerCircle}px;
    border-width: ${theme.radiobutton.sizes[size].border}px;
    border-color: ${theme.status[status].color};
  `}
`;

export const Label = styled.label<{ size: SizesType }>`
  color: ${({ theme }) => theme.gray4D};
  cursor: pointer;
  user-select: none;
  ${({ theme: { radiobutton }, size }) => css`
    font-size: ${radiobutton.sizes[size].fontSize}px;
    line-height: ${radiobutton.sizes[size].lineHeight}px;
  `}
`;

export const Input = styled.input<{ inputSize: SizesType; status: StatusButtonType }>`
  cursor: pointer;
  display: inline-block;
  position: relative;
  opacity: 0;
  margin: 0;
  box-sizing: border-box;
  z-index: 1;

  ${({ theme: { radiobutton }, inputSize }) => css`
    width: ${radiobutton.sizes[inputSize].outerCircle}px;
    height: ${radiobutton.sizes[inputSize].outerCircle}px;
  `}

  &:not(:checked) ~ ${Span} {
    border-color: ${({ theme }) => theme.gray80};
  }

  &:checked {
    cursor: default;
    & ~ ${Span}:after {
      display: block;
      border-radius: 50%;
      content: '';
      ${({ inputSize, theme, status }) => css`
        width: ${theme.radiobutton.sizes[inputSize].innerCircle}px;
        height: ${theme.radiobutton.sizes[inputSize].innerCircle}px;
        background-color: ${theme.status[status].color};
      `}
    }
    & ~ ${Label} {
      pointer-events: none;
    }
  }

  &:checked:disabled ~ ${Span}:after {
    background-color: ${({ theme }) => theme.grayCC};
  }

  &:disabled {
    cursor: default;
    & ~ ${Span} {
      border-color: ${({ theme }) => theme.grayCC};
    }
    & ~ ${Label} {
      color: ${({ theme }) => theme.grayCC};
      cursor: default;
    }
  }
`;
